export const OPTION_WRAPPER_TEST_IDS = {
    MULTI_SELECTOR: {
        DROP_DOWN: 'multi-selector-drop-down',
        SINGLE_VALUE: 'multi-selector-single-value',
        SINGLE_VALUE_WITH_COUNTER: 'multi-selector-single-value-with-counter',
        OPTION_VALUE: 'multi-selector-test-id',
        OPTION_VALUE_VISIBLE: 'multi-selector-test-option-visible',
        OPTION_VALUE_NOT_VISIBLE: 'multi-selector-test-option-not-visible',
        SWITCH_BUTTON: 'multi-selector-switch',
        OPTION_WITH_EDIT_AND_DELETE: 'option-with-edit-and-delete-test-id',
        DROP_DOWN_BUTTON: 'drop-down-button',
        DELETE_TAG_GROUP_MODAL: 'delete-tag-group-modal',
        ADVANCED_METRIC: 'isAdvancedMetric',
    },
};
